// extracted by mini-css-extract-plugin
module.exports = {"container":"mail_container__17W1A","body":"mail_body__3l_yu","bg-footer":"mail_bg-footer__tWlwH","image-bg":"mail_image-bg__1aC4X"};